/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import React from 'react';
import { TestIds } from '../testIds';
import { PageContainer } from '../components/layout/PageContainer';
import { SeedOrderForm } from '../features/seed-orders/SeedOrderForm';
import { SeedOrderPickUpStoreModalProvider } from '../features/seed-orders/components/PickUpStoreModal';
import { AddSeedModalProvider } from '../features/seed-orders/components/AddSeedModal';
import { CONTENT_LAYOUT_WIDTH } from '../util/consts';
import TitleBox from '../components/TitleBox';
import Section from '../components/layout/Section';
import SeedEditPriceProvider from '../features/seed-orders/components/useSeedEditPriceModal';
import { useSelector } from 'react-redux';
import { selectCanUseQuickOrder } from '../features/azure-b2c/storage';
import YesNoAction from '../components/YesNoAction';
import ContactCard from '../components/ContactCard';

export const SeedOrder = () => {
  const canUseSeed = useSelector(selectCanUseQuickOrder);

  if (!canUseSeed) {
    return (
      <PageContainer
        data-testid={TestIds.pages.seedOrder}
        sx={{ maxWidth: `${CONTENT_LAYOUT_WIDTH}px` }}
      >
        <YesNoAction
          display='Seed Unavailable'
          body='Seed orders are not available for this account. Please contact farmlands for getting your account eccommerce access.'
        />

        <ContactCard
          sx={{ mt: 4 }}
          title='Contact Farmlands to access Seed'
          {...{
            email: 'ask@farmlands.co.nz',
            phone: '0800 200 600',
          }}
        />
      </PageContainer>
    );
  }
  return (
    <PageContainer
      data-testid={TestIds.pages.seedOrder}
      sx={{ maxWidth: `${CONTENT_LAYOUT_WIDTH}px` }}
    >
      <SeedOrderPickUpStoreModalProvider>
        <SeedEditPriceProvider>
          <AddSeedModalProvider>
            <Section pb={6} mb={3}>
              <TitleBox display='CUSTOMISE YOUR SEED ORDER' />
            </Section>
            <SeedOrderForm />
          </AddSeedModalProvider>
        </SeedEditPriceProvider>
      </SeedOrderPickUpStoreModalProvider>
    </PageContainer>
  );
};
